<template>
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2857 2.28571H12.3429L11.6571 0.971429C11.3714 0.4 10.8 0 10.1143 0H5.82857C5.2 0 4.57143 0.342857 4.28571 0.971429L3.65714 2.28571H1.71429C0.742857 2.28571 0 3.02857 0 4V12C0 12.9143 0.742857 13.7143 1.71429 13.7143H14.2857C15.2571 13.7143 16 12.9143 16 12V4C16 3.02857 15.2571 2.28571 14.2857 2.28571ZM8 11.4286C6.11429 11.4286 4.57143 9.88571 4.57143 8C4.57143 6.11429 6.11429 4.57143 8 4.57143C9.88571 4.57143 11.4286 6.11429 11.4286 8C11.4286 9.88571 9.88571 11.4286 8 11.4286ZM14.2857 4.57143H13.1429C12.8 4.57143 12.5714 4.34286 12.5714 4C12.5714 3.65714 12.8 3.42857 13.1429 3.42857H14.2857C14.6286 3.42857 14.8571 3.65714 14.8571 4C14.8571 4.34286 14.6286 4.57143 14.2857 4.57143Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'CameraPhoto',
};
</script>
